import React, { useState, useEffect, useCallback, useContext, useMemo } from "react";
import {
  Box,
  Typography,
  Paper,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  Tab,
  Select,
  MenuItem,
  Chip,
  Switch,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid2"; 
import InputFilter from "../GeneralComponents/InputFilter";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import ListEmpty from "../GeneralComponents/ListEmpty";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";

import RepresentantesModalAdd from "./RepresentantesModalAdd";
import ModalCambioRepresentante from "./ModalCambioRepresentante";
import * as XLSX from "xlsx";
import ModalStandardCancel from "../GeneralComponents/ModalStandardCancel";
import ModalMassiveRepresentantes from "../GeneralComponents/ModalMassiveRepresentantes";
import {ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';

const columns = [
  {
    id: "checkbox",
    label: "",
    width: "5%",
    minWidth: "40px",
    align: "left",
  },
  { id: "rbd", label: "RBD", width: "5%", minWidth: "60px" },
  { id: "nombres", label: "Nombres", width: "12%", minWidth: "80px" },
  { id: "apellidos", label: "Apellidos", width: "12%", minWidth: "80px" },
  { id: "email", label: "Email", width: "12%", minWidth: "100px" },
  { id: "fecha_inclusion", label: "Fecha de inclusión", width: "12%", minWidth: "100px" },
  { id: "fecha_cambio_estado", label: "Fecha de cambio de estado", width: "12%", minWidth: "100px" },
  { id: "predeterminado", label: "Predeterminado", width: "12%", minWidth: "100px", align: "center", },
  {
    id: "run",
    label: "RUN",
    width: "16%",
    minWidth: "110px",
    align: "left",
  },
  {
    id: "tipo_representante",
    label: "Tipo Representante",
    width: "12%",
    minWidth: "80px",
    align: "left",
  },
];

export default function RepresentantesList() {
  const theme = useTheme();
  const [rows, setRows] = useState([]);
  const { includeRol, pageTitle, setPageTitle, userSesion } = useContext(GeneralContext);
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [selected, setSelected] = useState([]);
  const [tabFilter, setTabFilter] = useState("Todos"); 
  const [action, setAction] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = (action) => {setAction(action); setOpen(true);}
  const handleClose = (fromModal, successfulCount) =>{ setOpen(false); fetchData(fromModal, successfulCount)}
  const navigate = useNavigate();


  const [openAdd, setOpenAdd] = React.useState(false);
  const handleOpenAdd = () => { setOpenAdd(true);}
  const handleCloseAdd = (fromModal, successfulCount) =>{ setOpenAdd(false); fetchData(fromModal, successfulCount)}

  const [currentRow, setCurrentRow] = React.useState(null);
  const [changeTypeRow, setChangeTypeRow] = React.useState(null);
  const [openChangeType, setOpenChangeType] = React.useState(false);
  const [pendingType, setPendingType] = useState(null);


  const handleOpenChangeType = (row, newValue) => {setChangeTypeRow(row); setPendingType(newValue); setOpenChangeType(true);}
  const handleCloseChangeType = (changed) =>{ setOpenChangeType(false); if (changed) { fetchData(); } }


  const [defaultMsg, setDefaultMsg] = React.useState("");
  const [defaultBtnMsg, setDefaultBtnMsg] = React.useState("");
  const [openDefault, setOpenDefault] = React.useState(false);
  const handleOpenDefault = (row, newValue) => {setCurrentRow(row); setDefaultMsg(`¿Está seguro dejar a este Representante como determinado del Establecimiento RBD ${row.rbd}?`); setDefaultBtnMsg(row.predeterminado ? "OK, dejar como no Predeterminado" : "OK, dejar como Predeterminado"); setOpenDefault(true);}
  const handleCloseDefault = () =>{ setOpenDefault(false); }

  const fetchData = async (fromModal : boolean = false, count: number = 0) => {
    if(fromModal && count === 0){
      return;
    }
    setLoading(true);
    try {
      const response = await axios.listRepresentantes();
      const modifiedData = response.data.map((row) => ({
        ...row,
        checkbox: "",
        apellidos: row.apellidos ? row.apellidos : "",
        email: row.email ? row.email : "",
        fecha_inclusion: row.fecha_inclusion ? row.fecha_inclusion.split("T")[0]  : "-",
        fecha_cambio_estado: row.fecha_modificacion  ? row.fecha_modificacion.split("T")[0] : "-",
        tipo_representante: row.tipo_representante == "Representante EES" ? "Representante" : row.tipo_representante ,
        key: row.rbd + "_" + row.run,
        predeterminado: row.predeterminado === 1 ?  true : false,
      }));
      setRows(modifiedData);
      setTableData(modifiedData);

      const columnOrder = [
        "checkbox",
        "rbd",
        "nombres",
        "apellidos",
        "run",
        "email",
        "fecha_inclusion",
        "fecha_cambio_estado",
        "tipo_representante",
        "predeterminado"
      ];
      setFilteredColumns(
        columnOrder
          .map((id) => columns.find((column) => column.id === id))
          .filter(Boolean)
      );
    if (count !== 0){
      applyFilters(modifiedData);
    }
    setTabFilter("Todos");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePredeterminadoChange = (row, key, newValue) => {
    handleOpenDefault(row, newValue ? "Predeterminado" : "");
  };


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setPageTitle("Listado de Representantes");
  }, [pageTitle, setPageTitle]);


  const applyFilters = useCallback(() => {
    let filtered = Object.keys(filters).length
      ? rows.filter((item) =>
          Object.entries(filters).every(([key, val]) => item[key] === val)
        )
      : rows.slice();

    if (tabFilter === "Representantes") {
      filtered = filtered.filter((r) => r.tipo_representante === "Representante");
    } else if (tabFilter === "Temporales") {
      filtered = filtered.filter((r) => r.tipo_representante === "Temporal");
    } else if (tabFilter === "Deshabilitados") {
      filtered = filtered.filter((r) => r.tipo_representante === "Deshabilitado");
    }

    if (JSON.stringify(filtered) !== JSON.stringify(tableData)) {
      setSelected([]);
    }

    const maxPage = Math.floor((filtered.length - 1) / rowsPerPage);
    if (page > maxPage) {
      setPage(0);
    }

    setTableData(filtered);
  }, [filters, rows, tabFilter, rowsPerPage, page, tableData]);

  useEffect(() => {
    applyFilters();
  }, [filters, tabFilter, rows, applyFilters]);

  const filterRecords = (name, value) => {
    let filterObj = { ...filters };
    if (value == null) {
      delete filterObj[name];
    } else {
      filterObj[name] = value;
    }
    setFilters(filterObj);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const displayedRows = tableData;

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = tableData.map((n) => n.key);
    setSelected(newSelecteds);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleCheckboxClick = (key) => {
    const selectedIndex = selected.indexOf(key);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, key);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (key) => selected.indexOf(key) !== -1;

  const selectedRepresentantes = useMemo(
    () => rows.filter((r) => selected.includes(r.key)),
    [rows, selected]
  );

  const callChangePredeterminadoApi = async () => {
    const row = currentRow;

    try {
      const response = await axios.changePredeterminado(row.run, row.rbd);

      const updater = (prev) => {
        const nextValue = !row.predeterminado;

        return prev.map((r) => {
          if (r.rbd !== row.rbd) return r; 
          if (nextValue) {
            return { ...r, predeterminado: r.key === row.key };
          } else {
            return r.key === row.key ? { ...r, predeterminado: false } : r;
          }
        });
      };

      setRows(updater);
      setTableData(updater);
    } catch (err) {
      console.error(err);
    } finally {
      handleCloseDefault();
    }
  };


  const handleTabChange = (event, newValue) => {
    setSelected([]);
    setTabFilter(newValue);
  };

  const chipColor = (tipo) => {
    switch (tipo) {
      case "Representante":
        return "#2E7D32";
      case "Temporal":
        return "#FFE263";
      case "Deshabilitado":
        return "#ABABB5"; 
      default:
        return "#ABABB5";
    }
  };


    const downloadXLS = () => {
  //const selectedRows = tableData.filter((row) => selected.includes(row.id));

  const selectedRows = tableData;
  if (selectedRows.length === 0) {
    alert("No hay filas seleccionadas para descargar.");
    return;
  }

  /*const filteredData = selectedRows.map((row) => ({
    rbd: row.rbd,
    folio: row.folio,
    periodos: row.periodos.join(", "),
    tipo_contingencia: row.tipo_contingencia,
    id_operador: row.id_operador,
    operador: row.operador,
    rut_emisor: row.rut_emisor,
    id_zona: row.id_zona,
    estado: row.estado,
    estado_resumen: row.estado_resumen,
    fecha_creacion: row.fecha_creacion,
    fecha_inicio: row.tipo_contingencia === "PROGRAMADA" ? row.programada_inicio_contingencia+"T"+row.programada_hora_inicio : row.especifica_fecha_hora_ocurrencia ,
    fecha_termino: row.tipo_contingencia === "PROGRAMADA" ? row.programada_fin_contingencia+"T"+row.programada_hora_termino : row.especifica_fecha_hora_resolucion ,
    descripcion: row.tipo_contingencia === "PROGRAMADA" ? row.programada_descripcion : row.especifica_descripcion_falla,
    link_documento: row.ruta_url,
  }));*/




    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tabla");
    XLSX.writeFile(workbook, "tabla_representantes.xlsx");
  };

  return (
    <PageBody>
      <Box width="100%">
        <Grid container spacing={1} sx={{ marginBottom: "28px", marginTop: "-2rem" }} columns={12}>
          <Grid size={3}>
            <InputFilter data={rows} item={"nombres"} name={"Nombres"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"apellidos"} name={"Apellidos"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"email"} name={"Email"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"run"} name={"RUN"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"rbd"} name={"RBD"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"fecha_inclusion"} name={"Fecha de inclusión"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"fecha_cambio_estado"} name={"Fecha cambio de estado"} callback={filterRecords} />
          </Grid>
        </Grid>

        <Paper
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            background: "#FFFFFF",
            borderRadius: "0.25rem",
            marginBottom: "0.75rem",
          }}
        >
          <Typography
            variant="h1"
            color="inherit"
            noWrap
            sx={{ textAlign: "center", padding: "0.5rem" }}
          >
            LISTADO REPRESENTANTES
          </Typography>
        </Paper>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <CircularProgress />
            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Cargando...
            </Typography>
          </Box>
        ) : (
          <>
            <PageBgBlock pad="0">
              <Paper
                sx={{
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                  background: "#FFFFFF",
                  borderRadius: "0.25rem",
                  marginBottom: "0.75rem",
                }}
              >
                {/* Pestañas */}
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, backgroundColor: "#fff" }}>
                  <Tabs
                    value={tabFilter}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{
                      backgroundColor: "#fff",
                      "& .MuiTabs-indicator": {
                        height: 3,
                        backgroundColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <Tab
                      label="Todos"
                      value="Todos"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="Representantes"
                      value="Representantes"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="Temporales"
                      value="Temporales"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="Deshabilitados"
                      value="Deshabilitados"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                  </Tabs>
                </Box>

                <TableContainer>
                  <Table size="small" aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {filteredColumns.map((column, index) => (
                          <TableCell
                            key={"CL" + index}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.id === "checkbox" ? (
                              <Box display="flex" alignItems="center">
                                <Checkbox
                                  color="primary"
                                  indeterminate={
                                    selected.length > 0 &&
                                    selected.length < displayedRows.length
                                  }
                                  checked={
                                    selected.length > 0 &&
                                    selected.length === displayedRows.length
                                  }
                                  onChange={handleSelectAll}
                                  inputProps={{ "aria-label": "select all" }}
                                />
                                {column.label}
                              </Box>
                            ) : (
                              column.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {displayedRows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, rowIndex) => {
                          const isItemSelected = isSelected(row.key);
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={"TR" + rowIndex}
                            >
                              {filteredColumns.map((column, colIndex) => {
                                const value = row[column.id];
                                if (column.id === "checkbox") {
                                  return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                    >
                                      <Checkbox
                                        color="primary"
                                        checked={isItemSelected}
                                        onClick={() => handleCheckboxClick(row.key)}
                                        inputProps={{
                                          "aria-labelledby": row.key,
                                        }}
                                      />
                                    </TableCell>
                                  );
                                } else if (column.id === "predeterminado") {
                                 return (
                                      <TableCell
                                        key={"TC" + colIndex + rowIndex}
                                        align={column.align}
                                      >
                                        <Switch
                                          disabled={row.predeterminado || row.tipo_representante === "Deshabilitado" }
                                          checked={row.predeterminado}
                                          onChange={(e) =>
                                            handlePredeterminadoChange(row, row.key, e.target.checked)
                                          }
                                          color="primary"
                                          inputProps={{ "aria-label": "cambiar predeterminado" }}
                                        />
                                      </TableCell>
                                    );
                                } else if (column.id === "tipo_representante") {
                                  const current = row.tipo_representante;
                                  let options = [];
                                  if (current === "Representante") {
                                    options = ["Deshabilitado"];
                                  } else if (current === "Temporal") {
                                    options = ["Representante", "Deshabilitado"];
                                  } else if (current === "Deshabilitado") {
                                    options = ["Representante"];
                                  }
                                  return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                    >
                                      <Select
                                      disabled={!includeRol([ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN])}
                                        value={current}
                                        onChange={(e) =>
                                          handleOpenChangeType(row, e.target.value)
                                        }
                                        variant="standard"
                                        disableUnderline
                                        IconComponent={ExpandMoreIcon}
                                          sx={{
                                            minWidth: "130px",
                                            "&.Mui-disabled .MuiChip-root": {
                                              opacity: 1,
                                              backgroundColor: chipColor(current),
                                              color: current === "Temporal" ? "#000" : "#fff",
                                            },
                                            "&.Mui-disabled .MuiSelect-icon": {
                                              color: chipColor(current),
                                            },
                                          }}
                                        renderValue={() => (
                                          <Chip
                                            size="small"
                                            label={current}
                                            sx={{
                                              backgroundColor: chipColor(current),
                                              color: current === "Temporal" ? "#000" : "#fff",
                                              textFillColor: current === "Temporal" ? "#000" : "#fff",
                                            }}
                                          />
                                        )}
                                      >

                                      <MenuItem value={current} disabled>
                                          Pasar a {current}
                                        </MenuItem>
                                        {options.map((opt) => (
                                          <MenuItem key={opt} value={opt}>
                                            Pasar a {opt}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </TableCell>
                                  );
                                } else {
                                  return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                      sx={{wordBreak: column.id==="email" ? "break-word" : "none"}}
                                    >
                                      {value}
                                    </TableCell>
                                  );
                                }
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  {displayedRows.length === 0 && <ListEmpty />}
                </TableContainer>

                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={displayedRows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </PageBgBlock>

            {includeRol([ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN]) ? (
              <Grid container spacing={2} sx={{ display: "flex" }} columns={14}>
                <Grid size={3}>
                  <PageButtonWhite color="#2E7D32" bgColor="#C8E6C9" border="#C8E6C9" icon={<AddCircleOutlineOutlinedIcon/>}
                    onClick={handleOpenAdd}
                    width="100%"
                  >
                    Agregar Representante
                  </PageButtonWhite>
                </Grid>
                <Grid size={3}>
                  <PageButtonBlack
                    loading={selected.length === 0 || tabFilter === "Todos" || tabFilter === "Representantes"}
                    onClick={(e) => {e.preventDefault(); handleOpen("Representante")}}
                    width="100%"
                  >
                    Pasar a representante
                  </PageButtonBlack>
                </Grid>
                <Grid size={3}>
                  <PageButtonBlack
                    loading={selected.length === 0 || tabFilter === "Todos" || tabFilter === "Deshabilitados"}
                    onClick={(e) => {e.preventDefault(); handleOpen("Deshabilitado")}}
                    width="100%"
                  >
                    Pasar a deshabilitado
                  </PageButtonBlack>
                </Grid>
                <Grid size={5}>
                  <PageButtonWhite
                    loading={selected.length === 0}
                    onClick={downloadXLS}
                    width="100%"
                  >
                    Descarga selección en listado (.xlsx)
                  </PageButtonWhite>
                </Grid>
              </Grid>
            ) : null}
          </>
        )}
      </Box>
              <ModalMassiveRepresentantes
          open={open}
          btnText="Ir al listado"
          selected={selected}
          representantes={selectedRepresentantes}
          action={action}
          onClick={() => navigate("/Representantes_lista")}
          onClose={handleClose}
        ></ModalMassiveRepresentantes>

         <RepresentantesModalAdd
          open={openAdd}
          selected={selected}
          action={action}
          onClick={() => navigate("/Representantes_lista")}
          onClose={handleCloseAdd}
        ></RepresentantesModalAdd>

        <ModalCambioRepresentante
        open={openChangeType}
        representante={changeTypeRow}
        destino={pendingType}
        onClose={handleCloseChangeType}
      />


      <ModalStandardCancel
        open={openDefault}
        error={true}
        icon={<AssignmentIndOutlinedIcon color="error" sx={{ fontSize: 55 }}/>}
        title="Representante Predeterminado"
        qst={defaultMsg}
        msg="Esta actualizará los atributos del Representante y desde ahora podrá modificar ciertos datos en la ficha del RBD como dirección y Otros representantes."
        btnText={defaultBtnMsg}
        onClick={callChangePredeterminadoApi}
        onClose={handleCloseDefault}
      />
    </PageBody>
  );
}
